import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import RelativeTime from '../../../wire/relative-time';

const CaptionContainer = styled.div`
  display: flex;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-transform: uppercase;
  justify-content: space-start;
  align-content: center;

  span {
    font-size: ${props => (props.theme.isMobile ? 13 : 14)}px;
    line-height: 15px;
    margin-right: 8px;
  }

  span.main {
    color: ${props => props.theme.primaryColor};
  }

  span.secondary {
    color: ${props => props.theme.secondaryColor};
    font-size: ${props => (props.theme.isMobile ? 13 : 15)}px;
  }
`;

const VFlex = styled.div`
  display: flex;
  flex-direction: column;
`;

const HFlex = styled.div`
  display: flex;
`;

const Secondary = styled.span`
  &&, & > a {
    color: ${props => props.theme.secondaryColor};
  }
  margin-bottom: ${props => (props.theme.isMobile ? 4 : 0)}px;
  font-size: ${props => (props.theme.isMobile ? 12 : 14)}px !important;
`;

const Separator = styled(Secondary)`
  margin: 0 5px;
`;

const TimeSeparator = styled.span`
  ${props => props.isSponsored && `
    margin: 0 16px 0 8px!important;
  `};
  color: ${props => props.theme.secondaryColor};
`;

// eslint-disable-next-line complexity
export default function WireCaption({ wire }) {
  const { isMobile } = React.useContext(ThemeContext);
  const caption = {};
  if (wire.category || wire.series) {
    const seriesTitle = _.get(wire, 'series.title');
    caption.text = seriesTitle || _.get(wire, 'category.name');
    caption.url = seriesTitle ? `/${wire.series.slug}` : `/categories/${wire.category.slug}`;
  }

  return (
    <CaptionContainer>
      {!!isMobile && (
        <VFlex>
          {!!(wire.isSponsored) && (
            <Secondary>
              sponsored
            </Secondary>
          )}
          <HFlex>
            {!!caption.url && (
              <span className="main">
                <a href={caption.url} data-event-type="click" data-event="link_click">{caption.text}</a>
              </span>
            )}
            <TimeSeparator isSponsored={wire.isSponsored}>&bull;</TimeSeparator>
            <span className="wire__data secondary">
              <RelativeTime timestamp={wire.firstPublishedAt} useShortVersion={isMobile} />
            </span>
          </HFlex>
        </VFlex>
      )}
      {!isMobile && (
        <React.Fragment>
          {!!caption.url && (
            <span className="main">
              <a href={caption.url} data-event-type="click" data-event="link_click">{caption.text}</a>
            </span>
          )}
          {!!(caption.url && wire.isSponsored) && <Separator className="separator">&bull;</Separator>}
          {!!(wire.isSponsored) && (
            <Secondary>
              sponsored
            </Secondary>
          )}
          <TimeSeparator isSponsored={wire.isSponsored}>&bull;</TimeSeparator>
          <span className="wire__data secondary">
            <RelativeTime timestamp={wire.firstPublishedAt} />
          </span>
        </React.Fragment>
      )}
    </CaptionContainer>
  );
}

WireCaption.propTypes = {
  wire: PropTypes.shape({
    isSponsored: PropTypes.bool.isRequired,
    firstPublishedAt: PropTypes.string.isRequired,
    category: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    series: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
